const trainingCardTypes = {
  withDel: 'withDel',
  withoutDelEmpty: 'withoutDelEmpty',
  started: 'started',
};

export default trainingCardTypes;
